export const PLATFORM_HEADER_GRADIENT =
  "linear-gradient(to right, #0d4a3a, #00c060)";

export const PLATFORM_HEADER_MENU_OPEN_BG =
  "linear-gradient(#ffffff, #f8f8f8)";

export const PLATFORM_HEADER_MENU_OPEN_SHADOW =
  "0 1px 4px 0 rgba(44, 44, 44, 0.4)";

/** Primary CTA on gradient — aligned with trackcode.de hero buttons */
export const PLATFORM_HEADER_CTA_BG = "#ffffff";
export const PLATFORM_HEADER_CTA_TEXT = "#005a54";
export const PLATFORM_HEADER_CTA_SHADOW =
  "0 4px 12px rgba(16, 52, 51, 0.22)";
